import React from 'react'
import {Button, Header, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import { faDog } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {createUserLog} from "../../lib/api";
import {useSelector} from "react-redux";


const ConfirmMacro =({tagid,option,channel, type}) => {

    const [toggle, setToggle] = React.useState();
    const [open,setOpen]= React.useState(false);
    const ppid = useSelector(state => state.header.ppid);
    const user = useSelector(state => state.nav.user);
    const electronApp = useSelector(state => state.nav.electronApp);

    const handleOpen = () => setOpen( true);
    const handleClose = () => setOpen( false);

    const handleToggle =(event, {id}) => {
        setToggle(id);
        event.preventDefault();
        if(id === '1') {
            if(option === 1) {
                var adiodata = {'buttonClickType': channel, 'tags': tagid};
                socket.emit('button click', adiodata); 
                setOpen(false);
            }
            else if (option === 2) {
                var seqdata = {'buttonClickType': channel};
                socket.emit('button click', seqdata);
                setOpen(false);
            }
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ type: channel }),
                };
                createUserLog({ log }).catch(console.error);
            }
        }
        else if(id === '2'){
            setOpen(false);
        }
    }

    
    // update SOFC, channel.includes('PSM') -> 버튼 크기때문에 조건 별도 추가 by sumin
    // ^ Confirm Macro channel List :  Start PP, Abort Plant Shutdown, Plant Shutdown, Power Reset, Burner Relight, Clear Alarms
    return (
        <div>
            {option === 2 ?
                <Modal trigger = {type === 'watchdog' ? 
                                    <Button color='blue'> <FontAwesomeIcon icon={faDog} />  &nbsp;&nbsp;{channel} </Button>  
                                    : (channel.includes('PSM') && channel.includes('Set Date/Time')) ?
                                            <Button color ='blue' style={{marginBottom: '5px', maxWidth : '350px'}} >{channel} </Button>
                                                : <Button color ='blue' style={{marginBottom: '5px', maxWidth : '200px'}} >{channel} </Button>}
                       style = {styles.toggle}
                       open = {open}
                       onClose={handleClose}
                       onOpen={handleOpen}>
                    <Modal.Header>Confirmation</Modal.Header>
                    <Modal.Description>
                        <Header style = {styles.header}> Do you want to {channel}?</Header>
                    </Modal.Description>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id = '1'
                                active={toggle==='1'}
                                content='OK'
                                onClick={handleToggle}
                        />
                        <Button color={'red'}
                                size='small'
                                id = '2'
                                active={toggle==='2'}
                                content='Cancel'
                                onClick={handleToggle}
                        />
                    </Modal.Actions>
                </Modal>
                :
                <Modal trigger = {<Button color = 'blue'>CLEAR ALL OVERRIDES </Button>}
                       style = {styles.toggle}
                       open = {open}
                       onClose={handleClose}
                       onOpen={handleOpen}>
                    <Modal.Header>Confirmation</Modal.Header>
                    <Modal.Description>
                        <Header style = {styles.header}> Do you want to {channel}?</Header>
                    </Modal.Description>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id = '1'
                                active={toggle==='1'}
                                content='OK'
                                onClick={handleToggle}
                        />
                        <Button color={'red'}
                                size='small'
                                id = '2'
                                active={toggle==='2'}
                                content='Cancel'
                                onClick={handleToggle}
                        />
                    </Modal.Actions>
                </Modal>
            }

        </div>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    toggle: {
        maxWidth: '400px',
        marginTop: '5px',
        marginBottom: '25px',
        marginRight: '10px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '15px'
    }
}

export default ConfirmMacro;